import React, { Fragment, useRef } from "react";
import { OrderCategory, OrderCostingVersion, TApiOrderDetails } from "../../../../api/endpoints/Order";
import { TOrderProduct } from "../../../../api/endpoints/OrderProduct";
import { TApiSet } from "../../../../api/endpoints/Set";
import Col from "../../../../components/Common/Col";
import Row from "../../../../components/Common/Row";
import { VOLUME_LIMIT } from "../../../../constants/Constants";
import { deriveBcType, deriveDataSetName } from "../../../../utils/DataSet"
import { formatMegaBytes, withDefault } from "../../../../utils/Format";
import RealtimeProductDetails from "./ProductDetaiils";

interface IProps {
  order: TApiOrderDetails<OrderCategory.REALTIME>;
  orderCostingVersions: Array<OrderCostingVersion>;
  products: Array<TOrderProduct<OrderCategory.REALTIME>>;
  sets: Array<TApiSet>;
  onProductRemove: (product: TOrderProduct<OrderCategory.REALTIME>) => void;
  onProductDuplicate: (product: TOrderProduct<OrderCategory.REALTIME>) => void;
}

const RealtimeOrderDetails = (props: IProps) => {
  const {
    order,
    orderCostingVersions,
    sets,
    products,
    onProductRemove,
    onProductDuplicate
  } = props;
  const productRefs = useRef<Record<number, HTMLDivElement | null>>({});

  return (
    <Col className="realtime-order-details">
      {
        products.map((product, index) => {
          const productData = product.data;
          const datasetName = deriveDataSetName(productData, sets);
          const bcType = deriveBcType(productData, sets);

          return <RealtimeProductDetails
            ref={el => productRefs.current[product.id] = el}
            datasetName={datasetName}
            bcType={bcType}
            key={product.id}
            order={order}
            orderCostingVersions={orderCostingVersions}
            product={product}
            cost={order.cost?.data.per_product && order.cost?.data.per_product[index]}
            onProductRemove={onProductRemove}
            onProductDuplicate={onProductDuplicate}
          />;
        })
      }

      {
        order.cost.version === 'v1' && order.cost.data.total_cost &&
        <Fragment>
          <Row className="table__details--final-row highlighted">
            <Col sm={12} md={10} className="table__details--final-name">
              <p>Total daily volume</p>
              {
                order.cost.data.total_cost.average_daily_volume && (order.cost.data.total_cost.average_daily_volume > VOLUME_LIMIT) &&
                <small className="error">
                  Please note that for data deliveries via ECMWF, volume charges will apply once you have exceeded
                  100GB per day. ECMWF volume charges are: 2000 EUR per 10GB/day over 100GB/day.
                </small>
              }
            </Col>

            <Col sm={12} md={2} className="table__details--final-amount">
              <p>
                {
                  withDefault(
                    order.cost.data.total_cost.average_daily_volume ? (order.cost.data.total_cost.average_daily_volume * 0.000001) : undefined,
                    formatMegaBytes,
                    "--"
                  )
                }
              </p>
            </Col>
          </Row>
        </Fragment>
      }
    </Col>
  );
}

export default RealtimeOrderDetails;

